'use client'

import { env } from '@/config/client'
import { createStructuredLoggerFromConsole } from '@/lib/logger/client'
import { StructuredLogger } from '@/lib/logger/types'
import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useState } from 'react'

const defaultLogger = createStructuredLoggerFromConsole(console, {
  version: env.NEXT_PUBLIC_APP_VERSION,
})

export type LoggerProviderProps = {
  children?: ReactNode
}
const LoggerContext = createContext<StructuredLogger | undefined>(undefined)

const SetLoggerContext = createContext<Dispatch<SetStateAction<StructuredLogger | undefined>>>(
  () => {}
)

export function LoggerProvider({ children }: LoggerProviderProps) {
  const [logger, setLogger] = useState<StructuredLogger | undefined>(undefined)
  return (
    <LoggerContext.Provider value={logger}>
      <SetLoggerContext.Provider value={setLogger}>{children}</SetLoggerContext.Provider>
    </LoggerContext.Provider>
  )
}

export const useSetLogger = () => useContext(SetLoggerContext)

export type Logger = {
  logger: StructuredLogger
  type: 'app-insights' | 'console'
}

/**
 * FIXME: long-term, we should implement a logger-buffer
 * to store logs when app insights isn't loaded in, so we
 * can still capture and export telemetry without changing business
 * logic in the application.
 */
export const useLogger = (): Logger => {
  const logger = useContext(LoggerContext)
  if (logger !== undefined) {
    return { logger, type: 'app-insights' }
  }
  return { logger: defaultLogger, type: 'console' }
}
